<template>
  <section>
    <div v-if="obj" class="standardItem1">
      <div>{{ obj.title }}</div>
      <div>
        <span v-for="(item, index) in list" :key="index">
          <span v-if="item.type == 'text'">{{ item.label }}</span>
          <img
            v-if="item.type == 'img'"
            :src="require(`@/assets/icon/icon-${item.model}.png`)"
            alt=""
          >
          <span>{{ obj[item.model] }}</span>
        </span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComDtoData1',
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    obj: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
    handleRoute(v, x) {
      if (v == 5) {
        this.$router.push(x)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.standardItem1 {
  @include fun-layout(2);
  padding-top: 10px;
  > div {
    &:nth-child(1) {
      font-family: "AdobeHeitiStd-Regular";
      @include fun-design(4);
      text-align: center;
    }
    &:nth-child(2) {
      display: flex;
      flex-wrap: wrap;
      padding: 19px 0;
      justify-content: center;
      align-items: center;
      > span {
        font-family: "AdobeHeitiStd-Regular";
        font-size: 12px;
        color: #888;
        line-height: 24px;
        margin-right: 22px;
        img {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
